import { render } from "./Anonymous.vue?vue&type=template&id=c0dd0f42"
import script from "./Anonymous.vue?vue&type=script&lang=js"
export * from "./Anonymous.vue?vue&type=script&lang=js"
script.render = render

export default script